module.exports = __webpack_public_path__ + "images/accents/accent-comments@2x-0624a4c426feb7cdb161a6d0078f9299.webp";